import Storage from './Storage';

/**
 * Store OrderDetails
 * 
 */
class OrderDetails extends Storage {
    storeName = 'order_details_';

    /**
     * OrderDetails constructor
     * 
     * @param {string} id client id
     */
    constructor(id) {
        super();
        this.id = id;
        this.setKey();
    }

    /**
     * @override
     * 
     * Format data for store
     * 
     * @param {*} data data to store
     * @returns 
     */
    formatSetData(data) {
        let returnData = JSON.stringify(data);
        return returnData;
    }

    /**
     * @override
     * 
     * Format data for store
     * 
     * @param {*} data data to store
     * @returns 
     */
    formatSetDataOld(data) {
        let returnData = JSON.stringify(data);
        return returnData;
    }

}

export default OrderDetails;